export const countries = [
    "India"
]